
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { currentUser } from '../../lib/auth';


interface HeaderProps {
  toggleMobileSidebar: () => void;
}

export default function Header({ toggleMobileSidebar }: HeaderProps) {
  const user = currentUser()
  const navigate = useNavigate()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const logout = () => {
    localStorage.removeItem('authToken')
    navigate('/user-login')
  }

  return (
    <header className="flex items-center justify-between pt-3 px-4 py-3  bg-white dark:bg-gray-800 dark:text-white shadow-sm sticky top-0 z-40 h-14">
      <div className="flex items-center gap-4">
        <button className="md:hidden text-xl" onClick={toggleMobileSidebar}>
          ☰
        </button>
        
        <h1 className="text-lg font-semibold hidden md:block">
          {user.role === 'ADMIN' ? 'Admin Dashboard' : '' }
        </h1>
      </div>

      <div className="flex items-center gap-3">
        {/* <ThemeToggle /> */}
        <div className="relative">
          <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center uppercase">
              {user ? user.name[0] : 'U'}
            </div>
          </button>
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-700 border rounded shadow z-50">
              <div className="px-4 py-2 text-sm capitalize">Hello {user ? user.name : 'User'}</div>
              <button onClick={logout} className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-gray-100 dark:hover:bg-gray-600">
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
